/**
 * Implements a wallet page footer bar
 */
import { useEffect, useRef, useState } from 'react';
import Text from '../../../atoms/Text';
import { WalletMobileTab } from './WalletBody';

interface IMobileWalletPageFooter {
  selected: WalletMobileTab;
  onChange: (tab: WalletMobileTab) => void;
}

const MobileWalletPageFooter = ({
  selected,
  onChange,
}: IMobileWalletPageFooter) => {
  const prevScrollPosRef = useRef(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  const handleScroll = () => {
    const currentScrollPos = window.scrollY;
    const scrolledTo = currentScrollPos + window.innerHeight;
    const isReachBottom = scrolledTo > document.body.scrollHeight - 10;

    setVisible(
      !isReachBottom &&
        (prevScrollPosRef.current > currentScrollPos || currentScrollPos < 10)
    );
    prevScrollPosRef.current = currentScrollPos;
  };

  return (
    <div
      className={`wallet_page_mobile__footer ${
        visible
          ? 'wallet_page_mobile__footer--visible'
          : 'wallet_page_mobile__footer--hidden'
      }`}
    >
      <div
        className={`wallet_page_mobile__footer__block ${
          selected === WalletMobileTab.Watchlist
            ? 'wallet_page_mobile__footer__block--active'
            : 'wallet_page_mobile__footer__block--normal'
        }`}
        onClick={() => onChange(WalletMobileTab.Watchlist)}
      >
        <div className='wallet_page_mobile__footer__block__icon icon-list-open' />
        <Text size={12} className='wallet_page_mobile__footer__item_text'>
          {WalletMobileTab.Watchlist}
        </Text>
      </div>
      <div
        className={`wallet_page_mobile__footer__block ${
          selected === WalletMobileTab.Search
            ? 'wallet_page_mobile__footer__block--active'
            : 'wallet_page_mobile__footer__block--normal'
        }`}
        onClick={() => onChange(WalletMobileTab.Search)}
      >
        <div className='wallet_page_mobile__footer__block__icon icon-search-alt' />
        <Text size={12} className='wallet_page_mobile__footer__item_text'>
          {WalletMobileTab.Search}
        </Text>
      </div>
    </div>
  );
};

export default MobileWalletPageFooter;
